<template>
  <div>
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-navbar></layout-navbar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">

        <!-- Page Content -->
        <div class="content container-fluid">

          <div class="crms-title row bg-white">
            <div class="col  p-0">
              <h3 class="page-title m-0">
                        <span class="page-title-icon bg-gradient-primary text-white mr-2">
                          <i class="feather-grid"></i>
                        </span> Maßnahmenplan </h3>
            </div>
            <div class="col p-0 text-right">
              <ul class="breadcrumb bg-white float-right m-0 pl-0 pr-0">
                <li class="breadcrumb-item"><router-link to="/index">DSMS</router-link></li>
                <li class="breadcrumb-item active">Maßnahmenplan</li>
              </ul>
            </div>
          </div>

          <!-- Page Header -->
          <div class="page-header pt-3 mb-0 ">
            <div class="row">
              <div class="col">
                <div class="dropdown">
                  <a class="dropdown-toggle recently-viewed" href="#" role="button" data-toggle="dropdown" aria-expanded="false">Alle offene Maßnahmen</a>
                  <div class="dropdown-menu">
                    <a class="dropdown-item" href="#" @click="showTodos($event, 'all')">Alle Einträge</a>
                    <a class="dropdown-item" href="#" @click="showTodos($event, 'open')">Alle offene Maßnahmen</a>
                    <a class="dropdown-item" href="#" @click="showTodos($event, 'closed')">Alle abegeschlossene Maßnahmen</a>
                  </div>
                </div>
              </div>
              <div class="col text-right">
                <ul class="list-inline-item pl-0">
                  <li class="list-inline-item">
                    <button class="add btn btn-gradient-primary font-weight-bold text-white todo-list-add-btn btn-rounded" id="add-task" @click.prevent="addTodo">Neue Maßnahme</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Content Starts -->
          <Calendar
            language="de"
            :enable-range-selection="true"
            :enable-context-menu="true"
            :data-source="taskListCalendar"
            :context-menu-items="calendarMenuItems"
            @select-range="addCalendarTodo"
            @mouse-on-day="showCalendarTodo"
          ></Calendar>
          <!-- /Content End -->

        </div>
        <!-- /Page Content -->

      </div>
      <!-- /Page Wrapper -->
    </diV>
    <Popup :show="showPopup" :popup-objects="popupObjects" :title="popupTitle" :header-color="popupHeaderColor" :top="popupTop" :left="popupLeft" @editObject="editPopupObject" @deleteObject="deletePopupObject"></Popup>

    <!--modal section starts here-->
    <task :currentTodo="currentTodo" :origin="currentTodo.model" :editTodoProps="editTodo" @editTodoChanged="changeEditTodo" @todoUpdated="updateTodo">
      <template v-slot:steps>
        <Steps
          :totalSteps="currentTodo.steps"
          :taskID="currentTodo.id"
          :editTodo="editTodo"
          @stepsUpdated="setSteps"
        ></Steps>
      </template>
    </task>

    <GAP :componentID="objectModalName.question" :currentGap="objectVariables.question"></GAP>
    <VT :currentVT="objectVariables.vt">
      <template v-slot:fileUpload><file-upload :commentObject="objectVariables.vt" modelName="vt" modelVerboseName="VT"></file-upload></template>
      <template v-slot:comments><comments :commentObject="objectVariables.vt" modelName="vt" modelVerboseName="VT"></comments></template>
    </VT>
  </div>
</template>
<script>
import Calendar from 'v-year-calendar';
import 'v-year-calendar/locales/v-year-calendar.de';
import {service, baseURL} from '@/utils/request.js';
import {mapState, mapMutations} from 'vuex';
import Modal from '@/components/component/Modal'
import {deepCopy, initSelect2, originText} from '@/utils/index.js';
import {PRIORITY, newTodo, STATUS, getURL, objectModalName, newVT} from '@/utils/enums.js';
import datePicker from 'vue-bootstrap-datetimepicker';
import DataTableDSMS from "@/components/component/DataTableDSMS";
import fileUpload from "@/components/component/FileUploadComponent.vue";
import Steps from "@/components/component/Steps.vue";
import task from "@/components/component/TodoComponent.vue";
import GAP from "@/components/component/GapComponent.vue";
import VT from "@/components/component/VTComponent.vue";
import comments from "@/components/component/CommentComponent.vue";
import DisplayColumnsComponent from "@/components/component/DisplayColumnsComponent.vue";
import Popup from "@/components/component/Popup.vue";
export default {
  components: {DisplayColumnsComponent, fileUpload, comments, task, Steps, Modal, DataTableDSMS, GAP, VT, datePicker, Calendar, Popup},
  props: {
    questionID: {
      default: null,
      type: Number,
    },
    questionDescription: {
      default: '',
      type: String,
    },
    model: {
      default: 'question',
      type: String,
    }
  },
  data() {
    return {
      objectModalName: objectModalName,
      surveyJSON: '',
      task_list: [],
      stepTitle: '',
      current_question: {},
      current_survey: '',
      datetimeOptions: {
        format: 'YYYY-MM-DD',
        useCurrent: false,
      },
      currentObject: {},
      editTodo: false,
      currentGap: {
        topic: {
          name: '',
          description: '',
          new_intern_number: '',
        },
        last_answer: {
          question_answer: '',
          modified_on: '',
          modified_by: '',
        }
      },
      currentVT: {},
      objectVariables: {
        question: {
          topic: {
            name: '',
            description: '',
            new_intern_number: '',
          },
          last_answer: {
            question_answer: '',
            modified_on: '',
            modified_by: '',
          }
        },
        vt: newVT
      },
      question_list: [],
      status: STATUS,
      priority: PRIORITY,
      help_text: '',
      table: null,
      editor: null,
      currentTodo: newTodo,
      tipsTimeout: null,
      lastShownTip: null,
      calendarMenuItems: [
        {
          text: 'bearbeiten',
          click: evt => {
            this.setEdit(true)
            this.showTask(evt.id)
            this.showPopup = false
          }
        }
      ],
      showPopup: false,
      popupTitle: '',
      popupHeaderColor: '#ffffff80',
      popupTop: '50px',
      popupLeft: '50px',
      popupObjects: [],
      taskStaus: 'Offen',
      taskColor: {
        Offen: '#FF0000',
        Abgeschlossen: '#4CAF50',
        Annulliert: 'Annulliert',
        'In Bearbeitung': '#FF9800',
        Duplikat: '#9C27B0',
      },
    }
  },
  created() {
    this.getTasks()
  },
  destroyed() {
    if (this.tipsTimeout) clearTimeout(this.tipsTimeout)
  },
  computed: {
    ...mapState({accountid: state => state.account.accountid, userName: state => state.user.username, account: state => state.account, userID: state => state.user.id}),
    dataReady() {
      return this.task_list.length > 0
    },
    taskListCalendar() {
      let currentTaskList = this.taskStaus === 'All' ? this.task_list : this.task_list.filter((task) => task.status === this.taskStaus)
      return currentTaskList.map(task => {
        return {
          id: task.id,
          name: task.origin ? (task.origin === 'audit' ? task.remarks : `Aufgabe - ${originText(task.origin)}`) : `Aufgabe umsetzen bis ${task.due_date}`,
          description: task.description,
          startDate: task.start_date ? new Date(task.start_date) : new Date(new Date(task.due_date).setDate(new Date(task.due_date).getDate()-7)),
          endDate: new Date(task.due_date),
          color: this.taskColor[task.status]
        }
      })
    },
  },
  mounted() {
    initSelect2()
  },
  methods: {
    ...mapMutations({setEdit: "SET_EDIT"}),
    changeEditTodo(value) {
      this.editTodo = value
    },
    setSteps(steps) {
      this.currentTodo.steps = steps
    },
    showTask(objectID) {
      this.currentTodo = this.task_list.filter(item => item.id.toString() === objectID.toString())[0]
      $('#'+objectModalName.task).modal('show')
    },
    editPopupObject(objectID) {
      this.showPopup = false
      this.setEdit(true)
      this.showTask(objectID)
    },
    deletePopupObject(popupObject) {
      this.showPopup = false
      const that = this
      const objectID = popupObject.id
      const objectIndex = this.task_list.map(e=>e.id).indexOf(objectID)
      this.$confirm(
        {
          message: `Sicher, dass diese ${popupObject.title} gelöscht wird?`,
          button: {
            no: 'Nein',
            yes: 'Ja'
          },
          callback: confirm => {
            if (confirm) {
              service.request({
                url: `todos/v1/delete_task/${objectID}/`,
                method: 'DELETE',
                responseType: 'json'
              }).then(function(res) {
                if (objectIndex > -1) {
                  const sequence = that.task_list.filter(item => item.id === objectID)[0].sequence
                  that.task_list.splice(objectIndex, 1)
                  that.task_list = that.task_list.map(item => {
                    if (item.sequence > sequence) item.sequence = item.sequence - 1
                    return item
                  })
                }
                that.$vToastify.success(`${popupObject.title} ist erfolgreich gelöscht!`)
              })
            }
          }
        }
      )
    },
    showTodos(e, target) {
      e.preventDefault()
      if (target === 'open') this.taskStaus = 'Offen'
      if (target === 'closed') this.taskStaus = 'Abgeschlossen'
      if (target === 'all') this.taskStaus = 'All'
    },
    addTodo() {
      this.currentTodo = deepCopy(newTodo);
      this.setEdit(true)
      $('#'+objectModalName.task).modal('show')
    },
    showCalendarTodo(e) {
      if (e.events.length > 0) {
        this.showPopup = false
        if (this.tipsTimeout) {
          clearTimeout(this.tipsTimeout)
        }
        const position = e.element.getBoundingClientRect()
        this.popupObjects = []
        e.events.forEach(event => {
          this.currentTodo = this.task_list.filter(item => item.id == event.id)[0]
          this.currentTodo.title = event.name ? event.name : 'kein Name'
          this.currentTodo.headerColor = event.color + '80'
          this.popupObjects.push(this.currentTodo)
        })
        this.popupTop = (position.top + 10).toString() + 'px'
        this.popupLeft = position.left.toString() + 'px'
        this.tipsTimeout = setTimeout(() => this.showPopup = true, 500)
      } else {
        this.showPopup = false
      }
    },
    addCalendarTodo(e) {
      this.currentTodo = deepCopy(newTodo)
      this.currentTodo.due_date = `${e.endDate.getFullYear()}-${e.endDate.getMonth()+1}-${e.endDate.getDate()}`
      this.setEdit(true)
      $('#'+objectModalName.task).modal('show')
    },
    updateTodo(todoObject) {
      const todoIndex = this.task_list.findIndex(task => task.id === todoObject.id)
      if (todoIndex === -1) {
        this.task_list = this.task_list.map(item => {
          item.sequence = item.sequence + 1
          return item
        })
        this.task_list.push(todoObject)
      } else {
        this.task_list[todoIndex] = todoObject
      }
      $('.datatable').DataTable().clear().rows.add(this.task_list).draw()
      this.$vToastify.success('Maßnahme ist erfolgreich gespeichert!')
      $('#add_massnahme').modal('hide')
    },
    async getTasks() {
      service.request({
        url: this.questionID === null ? `todos/v1/get_tasks/${this.accountid}/` : `todos/v1/get_tasks_by_model/${this.questionID}/?model=${this.model}`,
        method: 'GET',
        responseType: 'json'
      }).then((response) => {
        this.task_list = response.data;
      }).catch(function(err) {
        console.log(err)
      })
    },
  }
}
</script>
<style scoped>
.calendar {
  min-height: 500px;
}
.dkl-span-new-line {
  display: block;
}
</style>
